import BSPView from "./BSPView.vue"

const BSPApp = {
  name: "BSPApp",
  path: "/bsp",
  route: {
    path: "/bsp",
    component: BSPView
  }
}

export default BSPApp
